import { Link } from 'react-router-dom';
import WTMonogram from './WTMonogram';
import '../styles/login.css';
import '../styles/legal.css';

interface LegalPageLayoutProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}

export default function LegalPageLayout({ title, subtitle, children }: LegalPageLayoutProps) {
  return (
    <div className="login-page legal-page">
      <div className="login-bg" aria-hidden="true" />
      <div className="login-card login-card-wide legal-card">
        <header className="login-header">
          <WTMonogram />
          <h1 className="login-title">{title}</h1>
          {subtitle && <p className="login-tagline">{subtitle}</p>}
        </header>
        <article className="legal-content">{children}</article>
        <footer className="legal-footer">
          <Link to="/" className="legal-back">← Retour à la connexion</Link>
        </footer>
      </div>
    </div>
  );
}
